import firebase from 'firebase';

const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyDWu-0fv0o4eStjGFRkDI19hhM2cFFAw7c",
    authDomain: "mywebsite-4accc.firebaseapp.com",
    databaseURL: "https://mywebsite-4accc.firebaseio.com",
    projectId: "mywebsite-4accc",
    storageBucket: "mywebsite-4accc.appspot.com",
    messagingSenderId: "335253610142",
    appId: "1:335253610142:web:98536cd6426feb110ba58f",
    measurementId: "G-ESKDYHFZB4"
});

const db = firebaseApp.firestore();

export {db};